module.exports = __webpack_public_path__ + "static/media/void_logo.486ff67a.jpg";